import React from 'react';
import PropTypes from 'prop-types';

const VideoAnimationSkills = ({ type }) => {
  if (type === 'freelancer') {
    return (
      <>
        <li>
          <a href="/jobs/2d-animators">2D animation jobs</a>
        </li>
        <li>
          <a href="/jobs/3d-animators">3D animation jobs</a>
        </li>
        <li>
          <a href="/jobs/animators">Animation jobs</a>
        </li>
        <li>
          <a href="/jobs/actors">Acting jobs</a>
        </li>
        <li>
          <a href="/jobs/illustrators Jobs">Illustration jobs</a>
        </li>
        <li>
          <a href="/jobs/motion-graphic-designers">
            Motion graphics design jobs
          </a>
        </li>
        <li>
          <a href="/jobs/videographers">Videographer jobs</a>
        </li>
        <li>
          <a href="/jobs/video-editor">Video editor jobs</a>
        </li>
        <li>
          <a href="/jobs/ai-video-editors">AI video editor jobs</a>
        </li>
        <li>
          <a href="/jobs/voice-directors">Voice director jobs</a>
        </li>
      </>
    );
  }

  return (
    <>
      <li>
        <a href="/find/2d-animators">2D animators</a>
      </li>
      <li>
        <a href="/find/3d-animators">3D animators</a>
      </li>
      <li>
        <a href="/find/animators">Animators</a>
      </li>
      <li>
        <a href="/find/animators/with/anime">Anime animators</a>
      </li>
      <li>
        <a href="/find/videographers">Videographers</a>
      </li>
      <li>
        <a href="/find/video-editors">Video editors</a>
      </li>
      <li>
        <a href="/find/ai-video-editors">AI video editors</a>
      </li>
      <li>
        <a href="/find/voice-directors">Voice directors</a>
      </li>
      <li>
        <a href="/find/illustrators">Illustrators</a>
      </li>
      <li>
        <a href="/find/motion-graphic-designers">Motion graphic designers</a>
      </li>
      <li>
        <a href="/find/content-producers/with/explainer-video">
          Explainer Videos
        </a>
      </li>
      <li>
        <a href="/find/actors">Actors</a>
      </li>
    </>
  );
};

VideoAnimationSkills.propTypes = {
  type: PropTypes.string.isRequired,
};

export default VideoAnimationSkills;
